import { Routes, Route, Navigate } from 'react-router-dom';
import UploadTypeNew from './UploadTypeNew';
import BookUpload from './BookUpload';
import ProductUpload from './ProductUpload';
import MenuUpload from './MenuUpload';
import CornerUpload from './CornerUpload';
import SpecialUpload from './SpecialUpload';
import CouponUpload from './CouponUpload';
import InformationUpload from './InformationUpload';
import IncentiveUpload from './IncentiveUpload';
import LotoUpload from './LotoUpload';
import PointUpload from './PointUpload';
import UploadList from './UploadList';

const UploadManagementMain = () => {
  return (
    <Routes>
      <Route path="/list" element={<UploadList />} />
      <Route path="/new" element={<UploadTypeNew />} />
      <Route path="/books" element={<BookUpload />} />
      <Route path="/products" element={<ProductUpload />} />
      <Route path="/menu" element={<MenuUpload />} />
      <Route path="/corner" element={<CornerUpload />} />
      <Route path="/special" element={<SpecialUpload />} />
      <Route path="/coupon" element={<CouponUpload />} />
      <Route path="/information" element={<InformationUpload />} />
      <Route path="/incentive" element={<IncentiveUpload />} />
      <Route path="/loto" element={<LotoUpload />} />
      <Route path="/point" element={<PointUpload />} />
      <Route path="/*" element={<Navigate to="/upload-management/new" replace />} />
    </Routes>
  );
};

export default UploadManagementMain;
